module.exports = __webpack_public_path__ + "img/toaleta.60e32f3d.jpg";